import React from "react";

import * as SC from "./PostEditorSwitch.styled";

import PostEditorFacebook from "../../PostEditors/post-editor-facebook/PostEditorFacebook";
import PostEditorYoutube from "../../PostEditors/post-editor-youtube/PostEditorYoutube";
import PostEditorInstagram from "../../PostEditors/PostEditor__Instagram/index";
import PostEditorTwitter from "../../PostEditors/post-editor-twitter/PostEditorTwitter";
import PostEditorLinkedIn from "../../PostEditors/post-editor-linkedin/PostEditorLinkedIn";
import PostEditorIndeed from "../../PostEditors/PostEditor__Indeed";
import PostEditorReddit from "../../PostEditors/post-editor-reddit/PostEditorReddit";
import PostEditorSnapchat from "../../PostEditors/post-editor-snapchat/PostEditorSnapchat";
import PostEditorPinterest from "../../PostEditors/post-editor-pinterest/PostEditorPinterest";
import PostEditorGoogleSearch from "../../PostEditors/post-editor-google-search/PostEditorGoogleSearch";
import PostEditorSpotify from "../../PostEditors/post-editor-spotify/PostEditorSpotify";
import PostEditorTikTok from "../../PostEditors/post-editor-tiktok/PostEditorTikTok";
import PostEditorLinkedInFeed from "../../PostEditors/post-editor-linkedIn-feed/PostEditorLinkedInFeed";
import PostEditorJobPage from "../../PostEditors/JobPage";
import PostEditorSkeleton from "../../PostEditors/post-editor-skeleton/PostEditorSkeleton";
import QualificationQuestionsEditing from "../../../QualificationQuestions/Campaign__Create_ATS";
import { useTranslation } from "react-i18next";

const googleChannels = ["youtube", "google-display", "ebay-kleinanzeigen"];

const PostEditorSwitch = ({
  selectedPostId,
  selectedPreviewChannel,
  mobile,
  postData,
  channelData,
  updatePost,
  updateChannelData,
  editable,
  clientView,
  isPrintView = false,
  selectedCreativeIndexToEdit,
  setSelectedCreativeIndexToEdit,
  campaignId,
  companyId,
  adsetId,
  orgaId,
  orgaLinkedInPageID,
  showAts,
  showLeadForm,
  jobPageLink,
  imageDimensions,
  hasAts,
  campaignLanguage
}) => {
  const { t } = useTranslation();

  if (!channelData || !postData) {
    return <PostEditorSkeleton mobile={mobile} campaignLanguage={campaignLanguage} />;
  }

  if (showAts) {
    return (
      <QualificationQuestionsEditing
        orgaId={orgaId}
        campaignId={campaignId}
        viewType="selfserviceEditing"
      />
    );
  }

  if (showLeadForm) {
    return (
      <PostEditorJobPage
        orgaId={orgaId}
        campaignId={campaignId}
        jobPageLink={jobPageLink}
        creatives={postData.creatives}
        companyId={companyId}
      />
    );
  }

  return selectedPreviewChannel === "facebook" ? (
    <div style={{ textAlign: "right" }}>
      <SC.CenterPost>
        <PostEditorFacebook
          orgaId={orgaId}
          campaignId={campaignId}
          selectedPostId={selectedPostId}
          postData={postData}
          channelData={channelData}
          updatePost={updatePost}
          updateChannelData={updateChannelData}
          mobile={mobile}
          editable={editable}
          channel={selectedPreviewChannel}
          clientView={clientView}
          adsetId={adsetId}
          selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
          setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
          imageDimensions={imageDimensions}
          hasAts={hasAts}
          campaignLanguage={campaignLanguage}
        />
      </SC.CenterPost>
    </div>
  ) : selectedPreviewChannel === "instagram" ? (
    <div style={{ textAlign: "right" }}>
      <SC.CenterPost>
        <PostEditorInstagram
          orgaId={orgaId}
          postData={postData}
          campaignId={campaignId}
          channelData={channelData}
          updatePost={updatePost}
          updateChannelData={updateChannelData}
          adsetId={adsetId}
          mobile={mobile}
          editable={editable}
          channel={selectedPreviewChannel}
          clientView={clientView}
          selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
          setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
          hasAts={hasAts}
          campaignLanguage={campaignLanguage}
        />
      </SC.CenterPost>
    </div>
  ) : googleChannels.includes(selectedPreviewChannel) ? (
    <div style={{ textAlign: "right" }}>
      <div style={{ marginTop: 5 }}>
        {/* Google Drive, YouTube, Ebay */}
        <PostEditorYoutube
          orgaId={orgaId}
          postData={postData}
          campaignId={campaignId}
          channelData={channelData}
          updatePost={updatePost}
          updateChannelData={updateChannelData}
          mobile={mobile}
          editable={editable}
          channel={selectedPreviewChannel}
          selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
          setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
          logoUrl={
            selectedPreviewChannel === "youtube"
              ? "/images/youtube_logo_preview.png"
              : selectedPreviewChannel === "google-display"
              ? "/images/google_logo_preview.png"
              : "/images/ebay_kleinanzeigen_logo_preview.png"
          }
          isPrintView={isPrintView}
          campaignLanguage={campaignLanguage}
        />
      </div>
    </div>
  ) : selectedPreviewChannel === "twitter" ? (
    <PostEditorTwitter
      orgaId={orgaId}
      campaignId={campaignId}
      postData={postData}
      channelData={channelData}
      updatePost={updatePost}
      updateChannelData={updateChannelData}
      mobile={mobile}
      editable={editable}
      channel={selectedPreviewChannel}
      selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
      setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
      campaignLanguage={campaignLanguage}
    />
  ) : selectedPreviewChannel === "linkedin" ? (
    <PostEditorLinkedIn
      orgaLinkedInPageID={orgaLinkedInPageID}
      postData={postData}
      campaignId={campaignId}
      channelData={channelData}
      updatePost={updatePost}
      updateChannelData={updateChannelData}
      mobile={mobile}
      editable={editable}
      channel={selectedPreviewChannel}
      clientView={clientView}
      campaignLanguage={campaignLanguage}
    />
  ) : selectedPreviewChannel === "indeed" ? (
    <PostEditorIndeed
      postData={postData}
      campaignId={campaignId}
      channelData={channelData}
      updatePost={updatePost}
      updateChannelData={updateChannelData}
      mobile={mobile}
      editable={editable}
      channel={selectedPreviewChannel}
      clientView={clientView}
      campaignLanguage={campaignLanguage}
    />
  ) : selectedPreviewChannel === "reddit" ? (
    <PostEditorReddit
      orgaId={orgaId}
      postData={postData}
      channelData={channelData}
      updatePost={updatePost}
      updateChannelData={updateChannelData}
      mobile={mobile}
      editable={editable}
      channel={selectedPreviewChannel}
      selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
      setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
      campaignLanguage={campaignLanguage}
    />
  ) : selectedPreviewChannel === "snapchat" ? (
    <PostEditorSnapchat
      orgaId={orgaId}
      postData={postData}
      channelData={channelData}
      updatePost={updatePost}
      updateChannelData={updateChannelData}
      editable={editable}
      channel={selectedPreviewChannel}
      selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
      setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
      campaignLanguage={campaignLanguage}
    />
  ) : selectedPreviewChannel === "google-search" ? (
    <PostEditorGoogleSearch
      postData={postData}
      campaignId={campaignId}
      channelData={channelData}
      updatePost={updatePost}
      updateChannelData={updateChannelData}
      mobile={mobile}
      editable={editable}
      channel={selectedPreviewChannel}
      clientView={clientView}
      campaignLanguage={campaignLanguage}
    />
  ) : selectedPreviewChannel === "pinterest" ? (
    <PostEditorPinterest
      orgaId={orgaId}
      postData={postData}
      campaignId={campaignId}
      channelData={channelData}
      updatePost={updatePost}
      updateChannelData={updateChannelData}
      mobile={mobile}
      editable={editable}
      channel={selectedPreviewChannel}
      selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
      setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
      campaignLanguage={campaignLanguage}
    />
  ) : selectedPreviewChannel === "spotify" ? (
    <SC.CenterPost>
      <PostEditorSpotify
        orgaId={orgaId}
        postData={postData}
        campaignId={campaignId}
        channelData={channelData}
        updatePost={updatePost}
        updateChannelData={updateChannelData}
        mobile={mobile}
        editable={editable}
        channel={selectedPreviewChannel}
        selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
        setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
        clientView={clientView}
        campaignLanguage={campaignLanguage}
      />
    </SC.CenterPost>
  ) : selectedPreviewChannel === "tiktok" ? (
    <PostEditorTikTok
      orgaId={orgaId}
      postData={postData}
      campaignId={campaignId}
      channelData={channelData}
      updatePost={updatePost}
      updateChannelData={updateChannelData}
      mobile={mobile}
      editable={editable}
      channel={selectedPreviewChannel}
      selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
      setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
      clientView={clientView}
      campaignLanguage={campaignLanguage}
    />
  ) : selectedPreviewChannel === "linkedin-feed" ? (
    <PostEditorLinkedInFeed
      orgaId={orgaId}
      postData={postData}
      campaignId={campaignId}
      channelData={channelData}
      updatePost={updatePost}
      updateChannelData={updateChannelData}
      mobile={mobile}
      editable={editable}
      channel={selectedPreviewChannel}
      selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
      setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
      clientView={clientView}
      campaignLanguage={campaignLanguage}
    />
  ) : (
    <SC.ComingSoon>{t("AVAILABLE SOON")}</SC.ComingSoon>
  );
};

export default PostEditorSwitch;
